var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandesPhovia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 702,
    viewBox: "0 0 161 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.22,
    height: 702,
    fill: "#DE860A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 13.22,
    height: 702,
    fill: "#E5AA0B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 13.22,
    height: 702,
    fill: "#E8D61A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    width: 13.22,
    height: 702,
    fill: "#A0B917"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 13.22,
    height: 702,
    fill: "#1E9735"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    width: 13.22,
    height: 702,
    fill: "#1A98CD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 13.22,
    height: 702,
    fill: "#415FA0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    width: 13.22,
    height: 702,
    fill: "#77468B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandesPhovia);
export default __webpack_public_path__ + "static/media/bandes_phovia.61af3843fa73ff33cb34f974614c3028.svg";
export { ForwardRef as ReactComponent };